module.exports = __webpack_public_path__ + "static/matterhorn-aa3bae7e3142ea3366d7865918333cac.jpg";